import { useGSAP } from "@gsap/react";
import { motion } from "framer-motion";
import gsap from "gsap";
import { Link } from "react-router-dom";
import { rightImg } from "../utils";
import VideoCarousel from "./VideoCarousel";
import { SparklesCore } from "./ui/SparklesCore";

const Highlights = () => {
  useGSAP(() => {
    gsap.to("#title", { opacity: 1, y: 0 });
    gsap.to(".link", { opacity: 1, y: 0, duration: 1, stagger: 0.25 });
  }, []);

  const linkVariants = {
    rest: { scale: 1 },
    hover: { 
      scale: 1.05,
      transition: { duration: 0.2 }
    }
  };

  return (
    <section
      id="highlights"
      className="w-screen overflow-hidden h-full common-padding bg-zinc relative"
    >
      {/* Subtle sparkles in background */}
      <div className="absolute inset-0 opacity-30">
        <SparklesCore
          id="highlightsSparkles"
          background="transparent"
          minSize={0.3}
          maxSize={1}
          particleDensity={20}
          particleColor="#fbbf24"
        />
      </div>
      
      <div className="screen-max-width relative z-10">
        <div className="mb-12 w-full md:flex items-end justify-between">
          <motion.h1 
            id="title" 
            className="section-heading bg-gradient-to-r from-amber-200 via-yellow-300 to-amber-200 bg-clip-text text-transparent"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Get What You Like.
          </motion.h1>

          <div className="flex flex-wrap items-end gap-5">
            {/* Link to Products Component */}
            <motion.div variants={linkVariants} initial="rest" whileHover="hover">
              <Link to="/products" className="link flex items-center group">
                <span className="relative">
                  View The Products
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-cyan-400 to-blue-500 group-hover:w-full transition-all duration-300" />
                </span>
                <img src={rightImg} alt="right" className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </motion.div>

            {/* Link to ZeroCoin Component */}
            <motion.div variants={linkVariants} initial="rest" whileHover="hover">
              <Link to="/zero-coin" className="link flex items-center group">
                <span className="relative">
                  Get The Coin
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-amber-400 to-yellow-500 group-hover:w-full transition-all duration-300" />
                </span>
                <img src={rightImg} alt="right" className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </motion.div>

            {/* Link to CryptoStore Component */}
            <motion.div variants={linkVariants} initial="rest" whileHover="hover">
              <Link to="/crypto-store" className="link flex items-center group">
                <span className="relative">
                  Get The Tokens
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-500 group-hover:w-full transition-all duration-300" />
                </span>
                <img src={rightImg} alt="right" className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
            </motion.div>

            {/* External Link to Open Account */}
            <motion.div variants={linkVariants} initial="rest" whileHover="hover">
              <a
                href="https://zero-bank.xyz"
                target="_blank"
                rel="noopener noreferrer"
                className="link flex items-center group"
              >
                <span className="relative">
                  Open Account
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-purple-400 to-pink-500 group-hover:w-full transition-all duration-300" />
                </span>
                <img src={rightImg} alt="right" className="ml-2 group-hover:translate-x-1 transition-transform" />
              </a>
            </motion.div>
          </div>
        </div>

        <VideoCarousel />
      </div>
    </section>
  );
};

export default Highlights;
